// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"81fc31e2","239":"86e7f033","453":"a81f0a7f","574":"43609f09","630":"80853d14","732":"d10cfe5d","913":"5bdfa71a","954":"35d3794a","970":"d5b4e45e"}[chunkId] + ".chunk.js";
};